import { render, staticRenderFns } from "./configuracionPlazosPtiModal.vue?vue&type=template&id=8db4b49c&scoped=true"
import script from "./configuracionPlazosPtiModal.vue?vue&type=script&lang=js"
export * from "./configuracionPlazosPtiModal.vue?vue&type=script&lang=js"
import style0 from "./configuracionPlazosPtiModal.vue?vue&type=style&index=0&id=8db4b49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db4b49c",
  null
  
)

export default component.exports